import AttentionBar from '@runway/attention-bar';
import DynamicArea from '@runway/dynamic-area';
import EnhancedForm from '@runway/enhanced-form';
import Header from '@runway/header';
import InputElement from '@runway/input-element';
import InputElementCheckbox from '@runway/input-element-checkbox';
import InputElementChoice from '@runway/input-element-choice';
import InputElementNumber from '@runway/input-element-number';
import InputElementDate from '@runway/input-element-date';
import InputElementBirthDate from '@runway/input-element-birthdate';
import InputElementSelect from '@runway/input-element-select';
import InputTextarea from '@runway/input-textarea';
import Toggle from '@runway/toggle';
import Autosuggest from "@runway/autosuggest";

// Internal Components
import AddressFinder from './components/address-finder/address-finder';
import PollEndpoint from './components/poll-endpoint/poll-endpoint';
import FormCustomEnrollPersonal from './components/form-custom-enroll-personal/form-custom-enroll-personal';
import MembershipTypeToggle from './components/membership-type-toggle/membership-type-toggle';
import PartnerEnrollmentPersonal from './components/partner-enrollment-personal/partner-enrollment-personal';
import CorporateMemberEnrollment from './components/corporate-member-enrollment/corporate-member-enrollment';
import AppointmentCreation from './components/appointment-creation/appointment-creation';

const componentList = [
    {
        name: 'rw-attention-bar',
        constructor: AttentionBar
    },
    {
        name: 'address-finder',
        constructor: AddressFinder
    },
    {
        name: 'poll-endpoint',
        constructor: PollEndpoint
    },
    {
        name: 'form-custom-enroll-personal',
        constructor: FormCustomEnrollPersonal
    },
    {
        name: 'membership-type-toggle',
        constructor: MembershipTypeToggle
    },
    {
        name: 'partner-enrollment-personal',
        constructor: PartnerEnrollmentPersonal
    },
    {
        name: 'corporate-member-enrollment',
        constructor: CorporateMemberEnrollment
    },
    {
        name: 'rw-dynamic-area',
        constructor: DynamicArea
    },
    {
        name: 'rw-enhanced-form',
        constructor: EnhancedForm
    },
    {
        name: 'rw-header',
        constructor: Header
    },
    {
        name: 'rw-input-element',
        constructor: InputElement
    },
    {
        name: 'rw-input-element-checkbox',
        constructor: InputElementCheckbox
    },
    {
        name: 'rw-input-element-choice',
        constructor: InputElementChoice
    },
    {
        name: 'rw-input-element-number',
        constructor: InputElementNumber
    },
    {
        name: 'rw-input-element-date',
        constructor: InputElementDate
    },
    {
        name: 'rw-input-element-birthdate',
        constructor: InputElementBirthDate
    },
    {
        name: 'rw-input-element-select',
        constructor: InputElementSelect
    },
    {
        name: 'rw-input-textarea',
        constructor: InputTextarea
    },
    {
        name: 'rw-toggle',
        constructor: Toggle
    },
    {
        name: 'rw-autosuggest',
        constructor: Autosuggest
    },
    {
        name: 'appointment-creation',
        constructor: AppointmentCreation
    }
];

export default componentList;
